import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useCancelEarnings } from "../../../";
import { CancelEarningsModalProps } from "./CancelEarningsModal.types";

import styles from "./CancelEarningsModal.module.scss";

const CANCEL_ORDER_FORM_ID = "REJECT_RETURN_FORM_ID";

const CancelEarningsModal = ({
  earningIds,
  isOpen,
  onClose,
  onSuccess
}: CancelEarningsModalProps) => {
  const { t } = useTranslation();

  const isMultiple = Array.isArray(earningIds);

  const { mutate: cancelEarnings, isLoading } = useCancelEarnings({
    onSuccess: () => {
      toast.success(
        isMultiple
          ? t("Selected earnings cancelled successfully")
          : t("Earning cancelled successfully")
      );
      onSuccess?.();
      onClose?.();
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      title={isMultiple ? t("Cancel Earnings") : t("Cancel Earning")}
      formId={CANCEL_ORDER_FORM_ID}
      okText="Confirm"
      isLoading={isLoading}
      onOk={() => {
        cancelEarnings({ earningIds: isMultiple ? earningIds : [earningIds] });
      }}
      contentClassName={styles.cancelEarningsModal}
      onClose={onClose}
    >
      <p className={styles.cancelEarningsModal_text}>
        {isMultiple
          ? t("Are you sure you want to cancel selected earnings?")
          : t("Are you sure you want to cancel the earning?")}
      </p>
    </Modal>
  );
};

export default CancelEarningsModal;
